import L from 'leaflet';
import { toString } from 'lodash';

import * as layerOps from '../../api/Layers/layer-operations';
import * as styleOps from '../../api/Styles/style-operations';

/**
 * Builds the TMS layer for the map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.layer - The layer object.
 * @param {object} arg.style - The style object.
 * @param {number} [arg.zIndex=10] - The zIndex for the layer.
 * @returns {object} The leaflet layer to add to the map.
 *
 */

const buildWMTSLayer = ({ layer, style, zIndex = 10 }) => {
  return L.tileLayer(
    `${layerOps.getURL(
      layer
    )}?service=WMTS&request=GetTile&version=1.0.0&layer=${layerOps.getWMTSLayer(
      layer
    )}&format=${layerOps.getWMTSFormats(layer)}&style=${layerOps.getWMTSStyle(
      layer
    )}&tilematrixset=${layerOps.getWMTSTileMatrixSetNames(
      layer
    )}&tilematrix={z}&tilerow={y}&tilecol={x}`,
    {
      attribution: layerOps.getAttribution(layer),
      format: layerOps.getWMTSFormats(layer),
      style: layerOps.getWMTSStyle(layer),
      tilematrixset: layerOps.getWMTSTileMatrixSetNames(layer),
      layer: layerOps.getWMTSLayer(layer),
      opacity: styleOps.getRasterOpacityPercentage(style) / 100,
      maxZoom: layerOps.getMaxZoom(layer),
      pane: toString(zIndex)
    }
  );
};

export default buildWMTSLayer;
